import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';


@Component({
  selector: 'g10-custom-form-fields',
  templateUrl: './custom-form-fields.component.html',
  styleUrls: ['./custom-form-fields.component.css']
})
export class CustomFormFieldsComponent implements OnInit {

  @Input() modalName;
  @Input() popup:boolean = true;
  @Input() editField;
  @Input() editIndex;
  @Input() isEdit:boolean;
  @Output() result:any= new EventEmitter();
  @Output() closeEvent:any= new EventEmitter();

  public fieldForm: FormGroup;
  public isFormShow:boolean = true;

  public isTextarea: boolean = false;
  public isPlaceHolder: boolean = false;
  public isCharacter: any = false;
  public isDate: boolean = false;   
  public isNumbers: boolean = false;
  public isDropdownOption: boolean = false;
  public isDropdownOptionMultiple: boolean = false;
  public isShowFormPreview: boolean = false;
  
  typeValue: any;
  formValData: any;
  NewArrOfCustomForm: any = [];
  customData = [];

  public formFieldChanged:boolean=false;

  public formObject:any = {};
  public formSubmitted:boolean = false;
  public selectOptions = {
    inputType: ['text', 'textarea', 'date', 'checkbox', 'radio', 'dropdown'],
    textType: ['text','email','password','number'],
    historyFutureDate: [ {name:'History date', value:'historydate'}, {name:'Future date', value:'futuredate'} ],
    chipInput: [],
  }

  // ChipInput
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(
    private fb: FormBuilder,){
      
     }

  ngOnInit(): void {
    this.fieldFormLoad();
    setTimeout(()=> { if(this.isEdit) this.patchEditValue(); },200);
  }

  fieldFormLoad() {
    this.fieldForm = this.fb.group({
        label: ['', [Validators.required]],
        type: ['', [Validators.required]],
        name: [''],
        textType: [''],
        required: [false],
        placeholder: [''],
        options: [''],
        multiselect: [''],
        hint: [''],
        characterLength: [''],
        sizemax: [''],
        sizemin: [''],
        historyFutureDate: [''],
        col: ['col-md-12'],
        multiline: [false]
    });
  }
  patchEditValue() {
    this.fieldForm.patchValue(
        {
            label: this.editField.label,
            type: this.editField.type,
            textType: this.editField.textType,
            name: this.editField.name,
            required: this.editField.required,
            placeholder: this.editField.placeholder,
            options: this.editField.options,
            multiselect: this.editField.multiselect,
            hint: this.editField.hint,
            characterLength: this.editField.characterLength,
            sizemax: this.editField.sizemax,
            sizemin: this.editField.sizemin,
            historyFutureDate: this.editField.historyFutureDate,
            col: this.editField.col
        });
    this.enableDisableFields(this.editField.type);
    this.selectOptions['chipInput'] = this.editField.options;
    this.formObject = { ...this.editField}
    this.customData.push(this.editField);
    this.isShowFormPreview = true;
  }

  addModelOptions(event: any) {
    const objKey = Object.keys(this.formObject);
    this.isFormShow = false;
    this.selectOptions['chipInput'] = [];
    for (const key of objKey) {
        if (key != 'type' && key != 'col') {
            delete this.formObject[key];
        }
    }
    const objKey1 = Object.keys(this.fieldForm.value);
    this.isFormShow = false;
    for (const key of objKey1) {
        if (key != 'type' && key != 'col') {
            this.fieldForm.controls[key].reset();
        }
    }
    this.enableDisableFields(event.value);
    this.isFormShow = true;
    this.formObject.type = event.value;
    this.formObject.value = '';
    if (event.value == 'checkbox' || event.value == 'radio' || event.value == 'dropdown') {
        this.formObject.options = [];
        this.selectOptions.chipInput = [];
    } else {
        delete this.formObject.options;
    }
  }
  
  enableDisableFields(type) {
    this.isTextarea = false;
    this.isPlaceHolder = false;
    this.isCharacter = false;
    this.isDate = false;
    this.isNumbers = false;
    this.isDropdownOption = false;
    this.isDropdownOptionMultiple = false;
    if (type == 'text') {
        this.isTextarea = true;
        this.isPlaceHolder = true;
        this.isCharacter = true; } 
    else if (type == 'textarea') {
        this.isPlaceHolder = true;
        this.isCharacter = true;
    } else if (type == 'date') {
        this.isDate = true;
    } else if (type == 'radio') {
        this.isDropdownOption = true;
    } else if (type == 'checkbox') {
        this.isDropdownOption = true;
    } else if (type == 'dropdown') {
        this.isDropdownOption = true;
        this.isDropdownOptionMultiple = true;
    }
  }


  onChangeFormPreview(event,field){
    if (this.isEdit) 
    console.log(event,field);
    this.formObject[field] = event.value;
    if (field == 'required') { this.formObject[field] = event.checked; };
    if (field == 'multiselect') { this.formObject[field] = event.checked; };
    if (field == 'sizemin') { 
      if ( this.formObject['sizemax'] && (this.formObject['sizemin'] > this.formObject['sizemax']) ) {
        this.formObject['sizemin'] = ''
    }
    }
    if (field == 'sizemax') {
         console.log(this.formObject['sizemin'], this.formObject['sizemax'])
        if (this.formObject['sizemax'] && (this.formObject['sizemin'] > this.formObject['sizemax']) ) {
             this.formObject['sizemax'] = ''
         }
     }
    if (field == 'options') {
        const obj = [];
        event.forEach(element => {
            obj.push({ name: element.name, value: element.name });
        });
        this.formObject.options = obj;
    }
    if (field == 'text' || field == 'textare' || field == 'date') {
        delete this.formObject.options;
    }
    if (field == 'textType') {

        this.isCharacter = false;
        this.isNumbers = false;
        if (event.value == 'text') {
            this.isCharacter = true;
        }
        if (event.value == 'number') {
            this.isNumbers = true;
        }
    }
    if (field == 'label' && !this.isEdit) {
        this.formObject['name']=this.addMoreFieldKeyName(event.value);
    }
    this.customData.pop();
    this.customData.push(this.formObject);
    if(this.formObject['type'] && this.formObject['label']){
      if(this.formObject['col']==undefined || this.formObject['col']=='') this.formObject['col']='col-md-12';
      if(this.formObject['required']==undefined) this.formObject['required'] = false;
      this.isShowFormPreview = true;
    }
    else this.isShowFormPreview = false;
  }

  addMoreFieldKeyName(value){
    let returnString='';
    if (value.includes(' ')){
        let splitValues = value.split(' ');    
        splitValues.filter((e,i)=>{ 
            if(i==0) returnString = e.toLowerCase(); 
            if(i!=0) {
                let nextWord = e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();                    
                returnString = returnString.concat(nextWord);
            }
        });
    }
    else returnString = value.toLowerCase();
    return returnString + Math.floor(Math.random() * 10000);
  }

  // chips

  addChipInput(event: MatChipInputEvent): void {
    console.log(event);
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
        this.selectOptions['chipInput'].push({ name: value.trim() });
        this.onChangeFormPreview(this.selectOptions['chipInput'], 'options');
    }
    // Reset the input value
    if (input) input.value = '';
  }

  removeChipInput(val): void {

      const index = this.selectOptions['chipInput'].indexOf(val);
      if (index >= 0) this.selectOptions['chipInput'].splice(index, 1);
      this.onChangeFormPreview(this.selectOptions['chipInput'], 'options');

  }

  // Label

  titlecaseTransform(event,field){
    if(event.value != ''){
      event.value = event.value.charAt(0).toUpperCase()+event.value.slice(1).toLowerCase();
      this.onChangeFormPreview(event,field);
    }
  }

  /* Invidual form field check */
  public checkError = (controlName: string, errorName: string) => {
    return this.fieldForm.controls[controlName].hasError(errorName);
  }

  // submit modal emitting data
  onSubmit(){
      this.formSubmitted = true;
    console.log(this.fieldForm.controls);
    if (this.fieldForm.valid){
        let obj = { ...this.formObject,}
        this.result.emit(obj);
        this.closePopup();
    }
  }
  closePopup(){
    this.closeEvent.emit(true);
  }

}
